import React from 'react';
import { Button } from '@mui/material';

import type { CopyResult } from './CopyQuestionsDialog';

interface CopyQuestionsActionsProps {
    copyResults: CopyResult[] | null;
    isCopying: boolean;
    selectedCampaignsCount: number;
    onClose: () => void;
    onCopy: () => void;
}

/**
 * Renders actions for the copy questions dialog.
 *
 * @param {CopyQuestionsActionsProps} props
 * @returns {JSX.Element}
 */
const CopyQuestionsActions: React.FC<CopyQuestionsActionsProps> = (props) => {
    const { copyResults, isCopying, selectedCampaignsCount, onClose, onCopy } = props;

    return (
        <>
            {copyResults ? (
                <Button onClick={onClose} variant="contained" color="primary">
                    Close
                </Button>
            ) : (
                <>
                    <Button onClick={onClose} variant="outlined" color="primary" disabled={isCopying}>
                        Cancel
                    </Button>
                    <Button onClick={onCopy} variant="contained" color="primary" disabled={selectedCampaignsCount === 0 || isCopying}>
                        {isCopying
                            ? 'Copying...'
                            : `Copy to ${selectedCampaignsCount} ${selectedCampaignsCount === 1 ? 'project' : 'projects'}`}
                    </Button>
                </>
            )}
        </>
    );
};

export default CopyQuestionsActions;
